import globalStore from "@/store";

const devices = {
  namespaced: true,
  state: {
    devices: [],
    device: { pkDeviceId: "", name: "", maxVoltage: null },
  },
  actions: {
    GET_ALL_DEVICES: function({ state }) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .get("/devices")
          .then(function(response) {
            globalStore.commit("devices/SET_DEVICES", response.data);
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
    GET_DEVICE_BY_ID: function({ state }, id) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .get("/devices/" + id)
          .then(function(response) {
            globalStore.commit("devices/SET_DEVICE", response.data);
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
    ADD_DEVICE: function({ state }, model) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .post("/devices", model)
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
    UPDATE_DEVICE: function({ state }, model) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .put("/devices", model)
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
    DELETE_DEVICE: function({ state }, id) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .delete("/devices/" + id)
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
  },
  mutations: {
    SET_DEVICES: function(state, model = null) {
      model == null ? (state.devices = []) : (state.devices = model);
    },
    SET_DEVICE: function(state, model = null) {
      model == null
        ? (state.device = { pkDeviceId: "", name: "" })
        : (state.device = model);
    },
  },
};
export default devices;
